import * as React from 'react';
import { styled, useTheme } from '@mui/material';
import passwordValidationRules from '../utils/password-validation-rules';
import { StyledHelperText } from './input-helper-text';
import { Icon } from './icon';

const StyledUl = styled('ul')({
  paddingLeft: '0px',
});

const PasswordValidationCard: React.FC<{ password: string }> = ({
  password,
}) => {
  const theme = useTheme();
  const rules = passwordValidationRules.map((rule) => ({
    ...rule,
    pass: rule.validate(password),
  }));

  return (
    <StyledUl>
      <li>
        <StyledHelperText>&bull; {rules[0].label}</StyledHelperText>
      </li>
      <li>
        <StyledHelperText>
          &bull; 3 of the following are required
        </StyledHelperText>
      </li>
      {rules.slice(1).map((rule) => (
        <li key={rule.key}>
          <StyledHelperText sx={{ paddingLeft: '12px' }}>
            {rule.pass && (
              <Icon
                sx={{ pr: '5px' }}
                iconName="check-circle-full"
                color={theme.palette.success.main}
                size="medium"
              />
            )}{' '}
            {rule.label}
          </StyledHelperText>
        </li>
      ))}
    </StyledUl>
  );
};

export const PasswordHints = styled(PasswordValidationCard)({
  marginLeft: '0px',
});

export default PasswordHints;
